import type { InputDescriptor } from "../../lib/types";

export interface EcommerceInputs {
  annualDirectSalesRevenue: number;
  onlineSalesPercent: number;
  averageOrderValue: number;
  csrHeadCount: number;
  averageCsrSalary: number;
  averageMinutesPerOrder: number;
  currentErrorRatePercent: number;
  averageErrorCost: number;
  implementationFee: number;
  monthlySoftwareAmount: number;
}

export const ECOMMERCE_DEFAULTS: EcommerceInputs = {
  annualDirectSalesRevenue: 10000000,
  onlineSalesPercent: 10,
  averageOrderValue: 165.34,
  csrHeadCount: 5,
  averageCsrSalary: 50000,
  averageMinutesPerOrder: 10,
  currentErrorRatePercent: 5,
  averageErrorCost: 50,
  implementationFee: 10000,
  monthlySoftwareAmount: 775
};

export const ECOMMERCE_FIELDS: InputDescriptor<keyof EcommerceInputs>[] = [
  {
    key: "annualDirectSalesRevenue",
    label: "Total annual revenue from direct sales?",
    kind: "currency",
    step: "1000"
  },
  {
    key: "onlineSalesPercent",
    label: "Expected % of sales originating online?",
    kind: "percent",
    step: "1"
  },
  {
    key: "averageOrderValue",
    label: "Estimated average order value?",
    kind: "currency",
    step: "0.01"
  },
  {
    key: "csrHeadCount",
    label: "Customer service reps dedicated to order entry?",
    kind: "number",
    step: "1"
  },
  {
    key: "averageCsrSalary",
    label: "Average customer service rep salary?",
    kind: "currency",
    step: "100"
  },
  {
    key: "averageMinutesPerOrder",
    label: "Average time spent by a CSR on an order?",
    kind: "minutes",
    step: "1"
  },
  {
    key: "currentErrorRatePercent",
    label: "Current error order rate %?",
    kind: "percent",
    step: "1"
  },
  {
    key: "averageErrorCost",
    label: "Average cost associated with each error?",
    kind: "currency",
    step: "1"
  },
  {
    key: "implementationFee",
    label: "One-time implementation fee?",
    kind: "currency",
    step: "100"
  },
  {
    key: "monthlySoftwareAmount",
    label: "Turnkey monthly software amount?",
    kind: "currency",
    step: "10"
  }
];
